import * as React from 'react';
import { connect } from 'react-redux';

import { AvailableMobilePlatforms, getPlatform, isLessThanDesktop } from 'utils/mobile-app';
import { getCookie, setCookie } from 'utils/cookie';
import { isPlainInfluencerOrganization } from 'utils/organization';

import type { Organization } from 'types';

type WrappedComponentType = {
  displayName?: string,
  name?: string,
  platform?: AvailableMobilePlatforms | null,
  onClose?: () => void
};

type OwnProps = {};

type StateProps = {
  organization: Organization | undefined | null
};

type Props = OwnProps & StateProps;

type State = {
  isClosed: boolean
};

const MAX_AGE_IN_DAYS = 1;

export default function withMobileBanner(
  WrappedComponent: React.ComponentType<WrappedComponentType>,
  cookieName: string
) {
  class MobileBannerHOC extends React.Component<Props, State> {
    static displayName = `MobileBannerHOC(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    state = {
      isClosed: false
    };

    handleClose = () => {
      this.setState({
        isClosed: true
      });

      setCookie(cookieName, 'closed', MAX_AGE_IN_DAYS);
    };

    render() {
      const { organization } = this.props;
      const { isClosed } = this.state;

      if (!organization || !isLessThanDesktop() || isClosed || getCookie(cookieName) === 'closed') {
        return null;
      }

      const hasInfluencerProfile = (organization.influencerProfiles && organization.influencerProfiles.length || 0) > 0;

      if (!isPlainInfluencerOrganization(organization) || !hasInfluencerProfile) {
        // should be visible only for influencers with a created profile
        return null;
      }

      return (
        <section style={{ position: 'sticky', top: 0, left: 0, right: 0, zIndex: 1001 }}>
          <WrappedComponent
            platform={getPlatform()}
            onClose={this.handleClose}
          />
        </section>
      );
    }
  }

  const mapStateToProps = ({ organizations }): StateProps => ({
    organization: organizations.currentOrganization
  });

  return connect(mapStateToProps)(MobileBannerHOC);
}
